/** Paso de las flechas. `any` o vacío avanza de a 1. */
export function stepSize(step: string | number | null | undefined): number {
  if (step == null || step === "" || step === "any") return 1;
  const n = typeof step === "number" ? step : Number(step);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

export function numberBound(value: string | number | null | undefined): number | undefined {
  if (value == null || value === "") return undefined;
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : undefined;
}

export function decimalPlaces(value: number): number {
  const text = String(value);
  const dot = text.indexOf(".");
  if (dot < 0) return 0;
  return text.length - dot - 1;
}

function formatStepped(n: number, places: number): string {
  if (places <= 0 || Number.isInteger(n)) return String(Math.round(n));
  return n.toFixed(places);
}

/**
 * Siguiente valor al pulsar subir o bajar.
 * Vacío + subir arranca en el mínimo, o en 0 si no hay mínimo.
 * Vacío + bajar no cambia. En el tope, esa flecha no avanza.
 */
export function nextSteppedValue(
  raw: string,
  dir: 1 | -1,
  step: string | number | null | undefined,
  min: string | number | null | undefined,
  max: string | number | null | undefined,
): string | null {
  const stepN = stepSize(step);
  const minN = numberBound(min);
  const maxN = numberBound(max);
  const trimmed = raw.trim().replace(",", ".");
  const empty = trimmed === "" || trimmed === "-" || trimmed === "." || trimmed === "-.";
  const current = empty ? Number.NaN : Number(trimmed);
  if (!empty && !Number.isFinite(current)) return null;

  let next: number;
  let places: number;
  if (!Number.isFinite(current)) {
    if (dir < 0) return null;
    next = minN ?? 0;
    places = decimalPlaces(stepN);
  } else {
    places = Math.max(decimalPlaces(stepN), decimalPlaces(current));
    const factor = 10 ** Math.min(places, 8);
    next = (Math.round(current * factor) + dir * Math.round(stepN * factor)) / factor;
  }

  if (minN != null && next < minN) {
    if (dir < 0) return null;
    next = minN;
  }
  if (maxN != null && next > maxN) {
    if (dir > 0) return null;
    next = maxN;
  }
  if (Number.isFinite(current) && next === current) return null;
  return formatStepped(next, places);
}
